import { Button, Card, CardProps, Col, Row, Space, Typography } from "antd";
import { isEmpty } from "lodash";
import { PropsWithChildren } from "react";
import { LeftOutlined } from "@ant-design/icons";

export interface NavigationCardProps {
  previousSteps?: string[],
  currentStep: string,
  onPreviousStep?: () => void,
}

const {Text} = Typography;

export const NavigationCard = ({ cardProps, previousSteps = [], currentStep, onPreviousStep, children }: { cardProps?: CardProps} & NavigationCardProps & PropsWithChildren ) => {

  return <Card
    {...cardProps}
    title={
      <Space direction={"vertical"}>
        <Button type={"link"} icon={<LeftOutlined/>} style={{paddingLeft: 0}} onClick={() => {
          onPreviousStep?.();
        }}>Torna indietro</Button>
        <Row>
          <Col>
            {!isEmpty(previousSteps) && <Text type={"secondary"}>{previousSteps?.join(" / ").concat(" / ")}</Text>}
            <Text>{currentStep}</Text>
          </Col>
        </Row>
      </Space>
    }
  >
    {children}
  </Card>;
};